import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  fill: "none",
  viewBox: "0 0 36 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FF5100",
      d: "M23.572 3.32a.75.75 0 0 1 .75.75v2.18h3.364c1.92 0 3.528 1.502 3.528 3.417v5.229a.75.75 0 0 1 .071.315.74.74 0 0 1-.071.314v12.808c0 1.915-1.608 3.417-3.527 3.417H8.24c-1.919 0-3.527-1.502-3.527-3.417V9.667c0-1.915 1.608-3.417 3.527-3.417h3.438V4.07a.75.75 0 0 1 1.5 0v2.18h9.643V4.07a.75.75 0 0 1 .75-.75M6.214 15.96v12.373c0 1.03.878 1.917 2.027 1.917h19.446c1.148 0 2.027-.887 2.027-1.917V15.961zM8.24 7.75c-1.149 0-2.027.887-2.027 1.917v4.794h23.5V9.667c0-1.03-.879-1.917-2.027-1.917h-3.365v1.892a.75.75 0 0 1-1.5 0V7.75H13.18v1.892a.75.75 0 0 1-1.5 0V7.75z"
    }, null, -1)
  ]))]))
}
export default { render: render }